import getCustomColorFromTextColor from './get-custom-color-from-text-color';

const cleanUpColorFromStylesheet = (
  cssStyleSheet,
  textColorCssVariable,
  shouldRemoveCustomColor = true
) => {
  if (!cssStyleSheet || !textColorCssVariable) return;

  const { cssRules } = cssStyleSheet;
  const customColorCssVariable = getCustomColorFromTextColor(textColorCssVariable);

  Object.entries(cssRules)
    .reverse()
    .forEach(([index, rule]) => {
      const { style } = rule;
      if (shouldRemoveCustomColor) {
        style.removeProperty(customColorCssVariable);
      }

      style.removeProperty(textColorCssVariable);

      // clean empty style rule
      // specifically for this operation, we reverse array of cssRules
      if (!style.cssText) cssStyleSheet.deleteRule(index);
    });
};

export default cleanUpColorFromStylesheet;
